<template lang="pug">
  .social-share(:class="{ '--opened': isOpened, '--down': direction === 'down', '--round': isRound }" :title="isOpened ? null : $t('share')")
    .social-share__inner
      SocialShareIcons
        .social-share__item.social-share__switcher(@click="toggle()")
          img(:src="require('./img/share.svg')" alt="share")
</template>

<script>
import SocialShareIcons from '~/components/SocialShare/SocialShareIcons'

export default {
  name: 'SocialShare',

  components: {
    SocialShareIcons
  },

  props: {
    direction: {
      type: String,
      default: 'left'
    },

    isRound: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isOpened: false
    }
  },

  mounted () {
    document.addEventListener('click', this.onClickOutside)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.onClickOutside)
  },

  methods: {
    toggle (value) {
      if (value !== undefined) {
        this.isOpened = value
      } else {
        this.isOpened = !this.isOpened
      }
    },

    onClickOutside ({ target }) {
      if (!this.$el.contains(target) && this.isOpened) {
        this.toggle(false)
      }
    },

    onSocialClick (social) {
      const screenSize = { height: screen.height, width: screen.width }
      const windowSize = {
        height: screenSize.height / 2,
        width: screenSize.width / 2
      }

      const top = screenSize.height / 2 - windowSize.height / 2
      const left = screenSize.width / 2 - windowSize.width / 2

      return window.open(
        social.url + this.$config.WWW_HOST + this.$route.path,
        'blank',
        `
         top=${top},
         left=${left},
         width=${windowSize.width},
         height=${windowSize.height},
         toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,
        `
      )
    }
  }
}
</script>

<style lang="scss">
.social-share {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 48px;
  height: fit-content;
  position: relative;

  &__switcher {
    cursor: pointer;

    &.social-share__item svg path {
      transition: 0.2s $easing;
      fill: #fff;
    }
  }

  .--down & {
    flex-direction: column;
  }

  &.--round {
    .social-share__inner {
      border-radius: 50%;
    }
  }

  &__inner {
    border-radius: 8px;
    background: $blue-grey60;
    overflow: hidden;
    width: 48px;
    height: 48px;
    transition: 0.2s $easing;
    position: absolute;
    right: 0;
    top: 0;
    will-change: width;

    .--down.--opened & {
      width: 48px;
      height: 230px;
    }

    .--opened & {
      width: 230px;

      border-radius: 8px !important;

      .social-share__switcher {
        svg,
        path {
          fill: $primary60;
        }
      }
    }
  }

  &:hover:not(.--opened) {
    .social-share__inner {
      background: $blue-grey50;
    }

    .social-share__switcher svg path {
      fill: $white;
    }
  }

  @media (max-width: $breakpointHeaderMobile) {
    min-height: 40px;
    min-width: 40px;

    &.--down.--opened .social-share__inner {
      width: 40px;
      height: 200px;
    }

    &__inner {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
